import api from '../libs/api';

export default {

  // ================= GET =================
    getSettings: (page = 1, perPage = 10, filters = {}) => {
    return api().get(`/setting-service-requests`, {
        params: { page, per_page: perPage, ...filters }
    }).then(res => res.data);
    },

  // ================= CREATE =================
  createSetting: (payload) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/setting-service-requests`, payload)
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          else reject(data);
        })
        .catch(reject);
    });
  },

  // ================= UPDATE =================
  updateSetting: (id, payload) => {
    return new Promise((resolve, reject) => {
      api()
        .put(`/setting-service-requests/${id}`, payload)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(data);
        })
        .catch(reject);
    });
  },

  // ================= DELETE =================
  deleteSetting: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/setting-service-requests/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(data);
        })
        .catch(reject);
    });
  },

};